const { connect } = require('react-redux');
const { context } = require('app-context');
const DirectMessagesPage = require('../components/DirectMessagesPage');
const { push: Push } = require('connected-react-router');

const selectors = context.selectors.all;
const actions   = context.actions;

const updateSortPreference = (sortType) => {

    return function (dispatch) {

        return dispatch(actions.profileManagement.updateUserPreferences({
            sortMessagesBy: sortType
        }))
            .catch((error) => {

                console.error('Failed to update sort preference:', error);
            });
    };
};

module.exports = connect(
    (state) => ({
        dmChannels: selectors.getDmChannels_forDirectMessagesPage(state) || [],
        twilioChannelsLoading: selectors.getTwilioChannelsLoading(state),
        activeRoleGroupFilter: selectors.getRoleGroupFilter_byName(state, selectors.getRoleGroupFilter(state, 'dms')),
        rolesInteractions: selectors.getCurrentUserRoleInteractions(state),
        rolePermissions: selectors.getCurrentUserRolePermissions(state),
        dmsFilter: selectors.getDMsFilter(state),
        allMessagesSortType: selectors.getSortMessagesByPreference(state),
        availableRoleGroups: selectors.getPeersUsedRoleGroups(state),
        roleGroupFilter: selectors.getRoleGroupFilter(state, 'dms'),
        debug: selectors.getDebug(state).groupSorting
    }),
    {
        showNotification: (msg) => actions.alerts.notification.push({ message: msg }),
        setDMsFilter: actions.app.setDMsFilter,
        setAllMessagesSortType: actions.chats.setAllMessagesSortType,
        updateSortPreference,
        // eslint-disable-next-line hapi/no-arrowception, hapi/hapi-scope-start
        setRoleGroupFilter: (val) => (dispatch) => {

            return dispatch(actions.app.setRoleGroupFilter({ dms: val }));
        },
        push: Push
    }
)(DirectMessagesPage);
